'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jbone = require('jbone');

var _jbone2 = _interopRequireDefault(_jbone);

var _view = require('../../core/view');

var _view2 = _interopRequireDefault(_view);

var _play = require('./play.scss');

var _play2 = _interopRequireDefault(_play);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlayView = function (_View) {
  _inherits(PlayView, _View);

  function PlayView(config) {
    _classCallCheck(this, PlayView);

    var _this = _possibleConstructorReturn(this, (PlayView.__proto__ || Object.getPrototypeOf(PlayView)).call(this, config));

    var callbacks = config.callbacks;


    _this._callbacks = callbacks;
    _this.$node = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['play-control'],
      'data-hook': 'playback-control'
    });

    _this.$playbackControl = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['playback-toggle'] + ' ' + _this.styleNames.icon,
      'data-hook': 'toggle-playback-button'
    });

    _this.$node.append(_this.$playbackControl);

    _this._bindEvents();
    return _this;
  }

  _createClass(PlayView, [{
    key: '_bindEvents',
    value: function _bindEvents() {
      this.$playbackControl[0].addEventListener('click', this._callbacks.onTogglePlaybackButtonClick);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this.$playbackControl[0].removeEventListener('click', this._callbacks.onTogglePlaybackButtonClick);
    }
  }, {
    key: 'setState',
    value: function setState(_ref) {
      var isPlaying = _ref.isPlaying;

      this.$playbackControl.toggleClass(this.styleNames.paused, !isPlaying);
    }
  }, {
    key: 'show',
    value: function show() {
      this.$node.toggleClass(this.styleNames.hidden, false);
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.$node.toggleClass(this.styleNames.hidden, true);
    }
  }, {
    key: 'getNode',
    value: function getNode() {
      return this.$node[0];
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this.$node.remove();

      delete this.$playbackControl;
      delete this.$node;
    }
  }]);

  return PlayView;
}(_view2.default);

PlayView.extendStyleNames(_play2.default);

exports.default = PlayView;
//# sourceMappingURL=play.view.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/ui/controls/play/play.view.js
// module id = 1698
// module chunks = 1 2 3